const url = {
  development: "http://localhost:4343",
  production: "https://api.cars.hisob.org",
};

const env = process.env.NODE_ENV;

export const BASE_URL = url.production || url[env] || url.development;
